<template>
    <div class="notification">
        <prime-button @click="closeModal" class="close-modal" text>
            <font-awesome-icon :icon="['fas', 'xmark']" />
        </prime-button>
        <div class="textToShow flex-row-with-gap" v-for="(value, key) in textToShow" :key="key">
            <span class="date-text">{{value.formattedDate}} </span>
            <span class="warning-text" v-html="value.text" />
        </div>
    </div>
</template>

<script setup lang="ts">
import { IGlobalNotification, useAlertStore } from '@/stores/alertStore.ts';
import { computed } from 'vue';
import PrimeButton from 'primevue/button';

const alertStore = useAlertStore();
const textToShow = computed<Array<IGlobalNotification>>(() => alertStore.globalNotificationsToShow);

function closeModal (): void {
    alertStore.removeAllGlobalNotifications();
}
</script>

<style lang="scss" scoped>
.notification {
    left: 0;
    right: 0;
    position: fixed;
    padding: var(--smallSpacing);
    z-index: 101;
    background-color: var(--neutral200);
    box-shadow: 0 8px 6px -6px black;
    border: 1px solid var(--lcpBlue);

    .textToShow {
        font-size: var(--defaultFontSize);
        gap: 50px;
        .date-text {
            font-weight: bold;
            color: white;
            margin-left: var(--smallSpacing);
        }
        .warning-text {
            justify-content: center;
            margin: var(--smallSpacing);
        }
    }

    .close-modal {
        cursor: pointer;
        float: right;
        font-size: 30px;
        height: 30px;
        width: 30px;
        color: var(--lcpBlue);
    }
}
</style>
